﻿import { opaccAjaxPlugin } from './vendor/script/opacc.static.js';
export default class ArtDetailHelper {
    constructor() {
        this.descriptionElementSelector = 'data-art-detail-description';
        this.showMoreBtnSelector = 'data-show-more-btn';
        this.showMoreTextGroupSelector = 'data-show-more-text-group';
        this.showLessTextGroupSelector = 'data-show-less-text-group';
        this.maxNumberOfDescriptionLines = 4;
        this.yourPriceSpan = document.querySelector('[data-your-price]');
        this.quantityInput = document.querySelector('input.basket-button-quantity');

        this.initShowMore();
        this.attachEventListener();
    }

    /**
     * Initialisiert die "Show More"-Funktion für alle Instanzen im Markup.
     */
    initShowMore() {
        const descriptionElements = document.querySelectorAll(`[${this.descriptionElementSelector}]`);
        descriptionElements.forEach((descriptionElement) => {
            this.checkDescriptionTextHeight(descriptionElement);
        });
    }

    /**
     * Prüft die Höhe eines Beschreibungselements und zeigt ggf. den "Mehr anzeigen"-Button.
     */
    checkDescriptionTextHeight(descriptionElement) {
        const lineHeight = parseFloat(getComputedStyle(descriptionElement).lineHeight);
        const descriptionScrollHeight = descriptionElement.scrollHeight;
        const numberOfLines = descriptionScrollHeight / lineHeight;

        const showMoreButton = descriptionElement.nextElementSibling.querySelector(`[${this.showMoreBtnSelector}]`);
        const displayShowMoreBtn = numberOfLines > this.maxNumberOfDescriptionLines;

        showMoreButton.closest('button').classList.toggle('article-button-show-more--visible', displayShowMoreBtn);
    }

    /**
     * Fügt Event-Listener für die Show-More-Buttons hinzu.
     */
    attachEventListener() {
        document.addEventListener('click', (e) => {
            if (e.target.hasAttribute(this.showMoreBtnSelector)) {
                const showMoreButton = e.target.closest('button');
                const descriptionElement = showMoreButton.previousElementSibling;

                // Max height von article-description entfernen
                descriptionElement.classList.toggle('article-description--expanded');

                // Toggle Text
                const showMoreTextGroup = showMoreButton.querySelector(`[${this.showMoreTextGroupSelector}]`);
                const showLessTextGroup = showMoreButton.querySelector(`[${this.showLessTextGroupSelector}]`);
                showMoreTextGroup.classList.toggle('article-hide-group');
                showLessTextGroup.classList.toggle('article-hide-group');
            }
        });

        this.registerQuantityChangedListener();
        this.registerIntialPriceCalcEvent();
    }

    registerQuantityChangedListener() {
        if(!this.quantityInput) return;

        const qunatityChangedHanlder = this.quantityChanedHandler.bind(this);

        this.quantityInput.addEventListener('keydown', qunatityChangedHanlder);

        const quantityButtons = document.querySelectorAll('button[data-op-qtychange]');
        quantityButtons.forEach((button) => {
            button.addEventListener('click', qunatityChangedHanlder);
        });

    }

    quantityChanedHandler() {

        if(this.eventDispatcher) {
			clearTimeout(this.eventDispatcher);
		}
		this.eventDispatcher = setTimeout(()=> {
            this.calculateNewPrice(this.quantityInput.value);
         }, 500);
    }

    /**
     * Mit dieser Funktion wird der "Ihr Preis" auf der Artikel Detailseite berechnet.
     * Dieser ist abhaengig von der Menge die beim Warenkorbbutton eingestellt wird.
     */
    calculateNewPrice(quantity) {
        const urlConatinerElement = document.querySelector('[data-quantity-url]');
        if(!urlConatinerElement) return;
        const actionUrl = urlConatinerElement.getAttribute('data-quantity-url');
        const data = {};
        const priceListHandler = this.updatePrice.bind(this, quantity);

        opaccAjaxPlugin.fetchAsynPostForm(actionUrl, data, priceListHandler);

    }

    updatePrice(quantity, result) {
        this.quantityPriceArray = result;

        if(!this.quantityPriceArray || !this.quantityPriceArray.data) return;

        let tmpPrice = this.quantityPriceArray.data[0].price;

        this.quantityPriceArray.data.forEach((quantityPriceObj) => {
            const objQuantityVal = parseInt(quantityPriceObj.quantity);
            if(objQuantityVal <= quantity) {
                tmpPrice = quantityPriceObj.price;
            }
        });

        this.yourPriceSpan.innerHTML = parseFloat(tmpPrice).toFixed(2);
    }

    /**
     * Mit dieser Funktion kann eine Neuberechnung des Preises von Aussen angestossen werden.
     */
    registerIntialPriceCalcEvent() {
        document.addEventListener('recalcArtDetailPrice', (event) => {
            this.calculateNewPrice(event.detail.initialValue);
        });
    }
}

new ArtDetailHelper();

